// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3289":"main-style.less","3445":"css-design-tokens-brevo"}[chunkId] || chunkId) + "." + {"502":"f03396c1a2ba6f4996e7","1360":"3edabc18bf05b2174c53","3289":"3b6296da079d1844a7a4","3445":"0845cf67ad32171be246"}[chunkId] + ".css";
};